import { useState, useEffect } from "react";

/** Breakpoints i px (matchar vanliga responsive-mönster) */
export const VIEWPORT_BREAKPOINTS = {
  tablet: 768,
  desktop: 1024,
} as const;

export type ViewportResult = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

function getViewportState(): ViewportResult {
  if (typeof window === "undefined") {
    return { isMobile: false, isTablet: false, isDesktop: true };
  }
  const width = window.innerWidth;
  const isMobile = width < VIEWPORT_BREAKPOINTS.tablet;
  const isTablet =
    width >= VIEWPORT_BREAKPOINTS.tablet && width < VIEWPORT_BREAKPOINTS.desktop;
  const isDesktop = width >= VIEWPORT_BREAKPOINTS.desktop;
  return { isMobile, isTablet, isDesktop };
}

/**
 * Hook som returnerar viewport-hjälpare: isDesktop, isTablet, isMobile.
 * Uppdateras vid fönsterresize.
 */
export function useViewport(): ViewportResult {
  const [viewport, setViewport] = useState<ViewportResult>(getViewportState);

  useEffect(() => {
    const tabletQuery = window.matchMedia(
      `(min-width: ${VIEWPORT_BREAKPOINTS.tablet}px)`
    );
    const desktopQuery = window.matchMedia(
      `(min-width: ${VIEWPORT_BREAKPOINTS.desktop}px)`
    );

    const update = () => setViewport(getViewportState());

    tabletQuery.addEventListener("change", update);
    desktopQuery.addEventListener("change", update);
    window.addEventListener("resize", update);

    return () => {
      tabletQuery.removeEventListener("change", update);
      desktopQuery.removeEventListener("change", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return viewport;
}
